import axios from 'axios'
import helper from './helper'
// let qs = require('querystring')
import qs from 'qs'

axios.defaults.withCredentials = true
let root = process.env.API_ROOT

// let root ="/"

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.common['token'] = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE2NDQ4MDg3OTcsImV4cCI6OTQyMDgwODc5NywiZGF0YSI6eyJ1c2VyX2lkIjo2NTJ9fQ.LuB8FdVWA_2sZQjdxjsFHfg5lnGn5SfHL1WqTrC8TUE"

function apiAxios(method, url, data, token) {
    return axios({
        method: method,
        //拼接参数
        url: method === 'GET' || method === 'DELETE' ? helper.queryString(url, data) : url,
        data: method === 'POST' || method === 'PUT' ? data : null,
        baseURL: root,
        timeout: 8000,
        // headers: { Authorization: `Bearer ${token}` },
        headers: {'Cache-Control': 'no-cache'},
        withCredentials: false
    })
}


export default {
    get: function(url, params, token) {
        return apiAxios('GET', url, params, token)
    },
    post: function(url, params, token) {
        return apiAxios('POST', url, params, token)
    },
    put: function(url, params, token) {
        return apiAxios('PUT', url, params, token)
    },
    delete: function(url, params, token) {
        return apiAxios('DELETE', url, params, token)
    },
}


// WEBPACK FOOTER //
// ./src/api/http.js